import { createAction, props } from "@ngrx/store";
import { ICreateDeviceCategoryRequest, IDeviceCategory, IUpdateDeviceCategoryRequest } from "src/app/devices/models/device-category";

// Get Device Categories
export const getDeviceCategories = createAction(
    '[DeviceCategories] Get Device Categories'
);

export const getDeviceCategoriesSuccess = createAction(
    '[DeviceCategories] Get Device Categories success', 
    props<{ deviceCategories: IDeviceCategory[] }>()
);

export const getDeviceCategoriesFailure = createAction(
    '[DeviceCategories] Get Device Categories failure',
    props<{error: string}>()
);

// Create Device Categories
export const createDeviceCategory = createAction(
    '[DeviceCategories] Create Device Category',
    props<{ deviceCategory: ICreateDeviceCategoryRequest }>()
);

export const createDeviceCategorySuccess = createAction(
    '[DeviceCategories] Create Device Category success',
    props<{ deviceCategory: IDeviceCategory }>()
);

export const createDeviceCategoryFailure = createAction(
    '[DeviceCategories] Create Device Category failure',
    props<{error: string}>()
);

// Update Device Categories
export const updateDeviceCategory = createAction(
    '[DeviceCategories] Update Device Category',
    props<{ deviceCategory: IUpdateDeviceCategoryRequest }>()
);

export const updateDeviceCategorySuccess = createAction(
    '[DeviceCategories] Update Device Category success',
    props<{ deviceCategory: IDeviceCategory }>()
);

export const updateDeviceCategoryFailure = createAction(
    '[DeviceCategories] Update Device Category failure',
    props<{error: string}>()
);

// Delete Device Categories
export const deleteDeviceCategory = createAction(
    '[DeviceCategories] Delete Device Category',
    props<{id: string}>()
);

export const deleteDeviceCategorySuccess = createAction(
    '[DeviceCategories] Delete Device Category success',
    props<{id: string}>()
);

export const deleteDeviceCategoryFailure = createAction(
    '[DeviceCategories] Delete Device Category failure',
    props<{error: string}>()
);